import sitelogo from '../../media/sitelogo.svg';

export default function SitemarkIcon() {
  return (
    <img
      src={sitelogo}
      alt="Purple Axolotls"
      style={{ height: 32, width: 'auto', marginRight: 16 }}
    />
  );
}
